module.exports = __webpack_public_path__ + "static/fonts/bahnschrift.a397d89c.ttf";